module.exports = __webpack_public_path__ + "static/media/img_23.7181e809.jpg";